// Waiting for PM assignment page
// Shown when a property manager has registered but hasn't been assigned to properties yet

import { useAuth } from '../../hooks/useAuth';
import { Button } from '../../components/ui';

export function WaitingForPMAssignmentPage() {
  const { user, logout, refreshUser } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  const handleRefresh = async () => {
    await refreshUser();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-lg w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <div className="mx-auto w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mb-4">
            <svg
              className="w-8 h-8 text-amber-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900">
            Almost There!
          </h1>
        </div>

        {/* Content */}
        <div className="card p-8 text-center">
          <p className="text-gray-700 mb-6">
            Hi <span className="font-semibold">{user?.name || 'there'}</span>, your account has been created successfully.
          </p>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
            <h2 className="font-semibold text-amber-800 mb-2">
              Waiting for Property Assignment
            </h2>
            <p className="text-sm text-amber-700">
              The organization owner needs to assign you to properties before you can start managing them.
              Please contact them and let them know you've registered with the email address below.
            </p>
          </div>

          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-500 mb-1">Your registered email</p>
            <p className="font-medium text-gray-900">{user?.email}</p>
          </div>

          <div className="space-y-4">
            <div className="flex items-start gap-3 text-left">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                <span className="text-sm font-semibold text-primary-600">1</span>
              </div>
              <div>
                <p className="text-sm text-gray-700">
                  Contact the organization owner and share your email address
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 text-left">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                <span className="text-sm font-semibold text-primary-600">2</span>
              </div>
              <div>
                <p className="text-sm text-gray-700">
                  They will invite you to the organization and assign you to manage specific properties
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 text-left">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                <span className="text-sm font-semibold text-primary-600">3</span>
              </div>
              <div>
                <p className="text-sm text-gray-700">
                  Once assigned, you can manage issues, tenants, and properties
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200 space-y-3">
            <Button
              variant="secondary"
              onClick={handleRefresh}
              className="w-full"
            >
              Check Again
            </Button>
            <p className="text-xs text-gray-500">
              If you believe you should already have access, please contact the organization owner.
            </p>
            <Button
              variant="ghost"
              onClick={handleLogout}
              className="w-full text-gray-600"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WaitingForPMAssignmentPage;
